import React from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build/build/ckeditor';
import { connect } from 'react-redux';
import { fullBackendPath } from 'core/helpers';

const RichTextEditor = (props) => {
  const { value, onChange, token, disabled } = props;

  const toolbarConfig = disabled ? { toolbar: [] } : {};

  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      onChange={(event, editor) => {
        const data = editor.getData();
        onChange?.(data);
      }}
      config={{
        simpleUpload: {
          uploadUrl: fullBackendPath('/api/ck-uploads'),
          withCredentials: false,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
        ...toolbarConfig,
      }}
      disabled={disabled}
    />
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

const mapDispatchToProps = () => ({});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <RichTextEditor {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
